module.exports = __webpack_public_path__ + "static/media/Pasted Graphic 12.3f79758a.png";